import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { Link } from '@fiverr-private/typography';
import { appTranslate } from '../../../i18n';
import { theme } from '../../../theme';
import { GoBackToFiverrIcon } from '../../icons';
import { GoLogoIcon } from '../../GoLogoIcon';
import { GoSidebarDesktopTab } from '../GoSidebarDesktopTab';
import { GoTabProps } from '../GoSidebar.types';

interface GoDesktopBarProps {
    tabs: GoTabProps[];
    homeUrl: string;
    backToFiverrUrl: string;
}

export const GoDesktopBar = ({ tabs, homeUrl, backToFiverrUrl }: GoDesktopBarProps) => (
    <Stack
        as="nav"
        direction="column"
        height="100%"
        width="max-content"
        flexShrink="0"
        alignItems="center"
        paddingY="6"
        paddingX="2"
        gap="0"
        style={{ backgroundColor: theme.colors.grey1200 }}
    >
        <Link href={homeUrl} style={{ display: 'flex' }}>
            <GoLogoIcon color={theme.colors.grey300} />
        </Link>
        <Box
            width={32}
            borderTopWidth="sm"
            borderStyle="solid"
            borderRadius="circle"
            marginY="6"
            style={{ borderColor: theme.colors.grey1100 }}
        />
        <Stack as="ul" gap="4" direction="column" width="100%" marginBottom="auto">
            {tabs.map((tabProps) => (
                <li key={tabProps.label}>
                    <GoSidebarDesktopTab {...tabProps} />
                </li>
            ))}
        </Stack>
        <Box
            width={32}
            borderTopWidth="sm"
            borderStyle="solid"
            borderRadius="circle"
            marginY="4"
            style={{ borderColor: theme.colors.grey1100 }}
        />
        <GoSidebarDesktopTab
            label={appTranslate('go_sidebar.links.back_to_fiverr')}
            Icon={GoBackToFiverrIcon}
            href={backToFiverrUrl}
            withoutBackground
        />
    </Stack>
);
